import { AppError, extractMessage } from '@/helpers'

export class MultisigError extends AppError {
  constructor(options: { userMessage?: string; originalError?: unknown }) {
    super({
      title: 'Multisig operation failed',
      userMessage: options.userMessage,
      originalError: options.originalError,
      context: 'multisig',
    })
    this.name = 'MultisigError'
  }

  static fromUnknown(error: unknown): MultisigError {
    const raw = extractMessage(error)
    const lower = raw.toLowerCase()

    if (lower.includes('not a member of group')) {
      return new MultisigError({
        userMessage: 'You are not a member of this group',
        originalError: error,
      })
    }

    if (lower.includes('unauthorized')) {
      return new MultisigError({
        userMessage: 'You are not authorized to perform this action',
        originalError: error,
      })
    }

    if (lower.includes('insufficient funds')) {
      return new MultisigError({
        userMessage: 'Insufficient funds to cover fees',
        originalError: error,
      })
    }

    if (lower.includes('proposal not found')) {
      return new MultisigError({
        userMessage: 'Proposal not found',
        originalError: error,
      })
    }

    if (lower.includes('group not found')) {
      return new MultisigError({
        userMessage: 'Group not found',
        originalError: error,
      })
    }

    return new MultisigError({
      userMessage: raw || undefined,
      originalError: error,
    })
  }
}
